import React, { useEffect } from 'react';
import { AlertTriangle, Globe } from 'lucide-react';
import { usePermissions } from '../../../context/PermissionContext';
import { useSetupChecklist } from './SetupChecklistTab';

export const SetupReadinessBanner = ({ token, activeTab, onNavigate }) => {
  const { canView } = usePermissions();
  const allowed = canView('full_admin_only');
  const [d, , reload] = useSetupChecklist(token, allowed);
  useEffect(() => { reload(); }, [activeTab, reload]);
  if (!allowed || !d || activeTab === 'setup-checklist') return null;
  const remind = d.publish_reminder?.reminder;
  if (d.production_ready && !remind) return null;
  return (
    <>
    {remind && (
      <div className="mx-4 sm:mx-6 mt-4 border border-amber-200 bg-amber-50 rounded-lg px-4 py-2 flex flex-wrap items-center gap-2 text-sm" data-testid="publish-reminder-banner">
        <Globe className="w-4 h-4 text-amber-700" />
        <span className="font-semibold text-amber-900">Republish needed:</span>
        <span className="text-amber-800">search and share previews don't match Company Profile yet.</span>
        <button type="button" className="underline text-amber-900 font-medium" onClick={() => onNavigate('setup-checklist')} data-testid="publish-reminder-banner-open">Review</button>
      </div>
    )}
    {!d.production_ready && <div className="mx-4 sm:mx-6 mt-4 border border-red-200 bg-red-50 rounded-lg px-4 py-2 flex flex-wrap items-center gap-2 text-sm" data-testid="setup-not-ready-banner">
      <AlertTriangle className="w-4 h-4 text-red-600" />
      <span className="font-semibold text-red-800">Not ready for production:</span>
      <span className="text-red-700">{d.not_ready.join(', ')} {d.not_ready.length === 1 ? 'needs' : 'need'} setup.</span>
      <button type="button" className="underline text-red-800 font-medium" onClick={() => onNavigate('setup-checklist')} data-testid="setup-banner-open">Open Setup Checklist</button>
    </div>}
    </>
  );
};
